import { inject } from "vue"
import type { LayoutController } from "@/controllers/layout-controller"
import { useModelFormStore } from "@/store/model-forms.store"

// PNTS-12313: superuser impersonation. Starting it adds an impersonation column
// to the planning page, which runs the app as the target user in an iframe (see
// ColumnImpersonation.vue). The superuser's own page is never impersonated, and
// closing the column ends the impersonation.
export function useImpersonation(
  layoutController: LayoutController | null = inject<LayoutController | null>(
    "layoutController",
    null
  )
) {
  function startImpersonation(userId: string, label: string) {
    if (!layoutController) {
      throw new Error("Impersonation needs the planning layout (layoutController is not provided)")
    }
    layoutController.addImpersonationColumn(userId, label)

    // Close any open forms (the button lives in one) so the new column is visible.
    const modelFormStore = useModelFormStore()
    for (const config of [...modelFormStore.modelFormConfigs]) {
      modelFormStore.closeForm(config.id!)
    }
  }

  return {
    startImpersonation
  }
}
